const INFO = {
	main: {
		title: "Ryan Carr - Full Stack Engineer | AI-Accelerated Development",
		name: "Ryan Carr",
		email: "ryan@ryancarr.dev",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/ryanecarr/",
		linkedin: "https://linkedin.com/in/ryanecarr/",
	},

	homepage: {
		title: "Ryan Carr",
		subtitle: "Full Stack Engineer | AI-Accelerated Development",
		description:
			"I build and ship production applications end to end — from front end to cloud to AI. My work spans React and Angular front ends, serverless backends on Firebase and Google Cloud, and AI-driven features powered by the Claude API. I leverage AI-accelerated development workflows daily through tools like Claude Code and GitHub Copilot, delivering at speed without cutting corners on quality. I'm experienced in designing, building, and deploying enterprise-grade, public-facing applications with clean architecture and a focus on real user impact.",
	},

	about: {
		title: "I’m Ryan Carr — a full stack engineer building from front end to cloud to AI.",
		description:
			"I build and ship production applications end to end. My work spans React and Angular front ends, serverless backends on Firebase and Google Cloud, and AI-driven features powered by the Claude API. I leverage AI-accelerated development workflows daily through tools like Claude Code and GitHub Copilot, delivering at speed without cutting corners on quality. I’m experienced in designing, building, and deploying enterprise-grade, public-facing applications with clean architecture and a focus on real user impact.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Extended Vehicle Care",
			description:
				"Extended Vehicle Care is a cutting-edge web platform designed to offer consumers a seamless experience in purchasing after market warranty products directly online. Built with React on the frontend and powered by a robust Java Spring Boot backend API, Extended Vehicle Care provides a user-friendly interface for browsing, selecting, and purchasing various warranty plans tailored to individual needs.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://avp.allstate.com/",
		},

		{
			title: "Allstate Dealer Services",
			description:
				"Allstate Dealer Services marketing website, meticulously crafted with .NET MVC, Bootstrap, and JavaScript, is a gateway to exploring a range of aftermarket warranty products designed to safeguard vehicles.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://www.allstatedealerservices.com/",
		},
	],
};

export default INFO;
